import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { FormProvider, useForm } from 'react-hook-form'

import { camelToWords } from '@/utils/stringHelper'
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'

import { Input } from '@/components/Form'
import useSystemVariable from '../../useSystemVariable'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

const SystemVariableDetailModal = ({ modalDetail, setModalDetail }) => {
  // Redux
  const { show, type, isCreate, detail } = modalDetail

  // Hook
  const { useCreateSystemVariable, useRemoveSystemVariable, useUpdateSystemVariable } = useSystemVariable()

  const createSystemVariable = useCreateSystemVariable(type)
  const updateSystemVariable = useUpdateSystemVariable(type)
  const methods = useForm({ defaultValues: detail })
  const dispatch = useDispatch()

  useEffect(() => {
    methods.reset(detail)
  }, [detail, methods])

  // Handler

  const closeModal = () => {
    setModalDetail({
      show: false,
      type: '',
      isCreate: true,
      detail: {},
    })
  }
  const onSubmit = async (data) => {
    console.log(data)
    try {
      dispatch(showLoadingOverlay())
      if (isCreate) {
        const res = await createSystemVariable.mutateAsync({
          ...data,
          type: type,
        })
      } else {
        if (!detail._id) {
          return
        }
        updateSystemVariable.mutateAsync({ id: detail._id, data })
      }
      closeModal()
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'40%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>{isCreate ? 'Add' : 'Update'} System Variables</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <VStack>
                <Input name="code" label="Code" type="text" placeholder="Enter value" isRow />
                <Input name="name" label={`${camelToWords(type)} Name`} type="text" placeholder="Enter value" isRow />
              </VStack>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" type="submit">
                  {isCreate ? 'Add' : 'Update'}
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default SystemVariableDetailModal
